import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-132c6bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fieldWrapper" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_5 = ["checked", "onChange"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormCheckboxGroupField',
  props: {
    options: null,
    includedOptions: null,
    excludedOptions: null,
    modelValue: null,
    label: null,
    description: null,
    stacked: { type: Boolean },
    validator: null,
    validationId: null,
    isDisabled: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  options: object,
  includedOptions?: any[],
  excludedOptions?: any[],
  modelValue?: any[]|null,
  label?: string,
  description?: string,
  stacked?: boolean,
  validator?: (fieldId: any, val: any) => boolean,
  validationId?: string,
  isDisabled?: boolean
}



// Event for two-way binding

const onChanged = (val: any) => {
  // Toggle val
  const items = props.modelValue || [];

  if (items.includes(val)) {
    emit('update:modelValue', items.filter(i => i != val));
  }
  else {
    emit('update:modelValue', [val, ...items]);
  }
};

const allowedOptions = computed(() => {
  if (props.includedOptions) {
    return Object.fromEntries(
      Object.entries(props.options).filter(([k,v]) => props.includedOptions!.includes(v))
    );
  } else if (props.excludedOptions) {
    return Object.fromEntries(
      Object.entries(props.options).filter(([k,v]) => !props.excludedOptions!.includes(v))
    );
  } else {
    return props.options;
  }  
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "top")
    ]),
    (__props.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["control checkboxGroup", {stacked: __props.stacked}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allowedOptions), (optionValue, optionLabel) => {
        return (_openBlock(), _createElementBlock("label", {
          class: "checkbox checkboxLabel",
          key: optionValue
        }, [
          _createElementVNode("input", {
            ref_for: true,
            ref: "inputElem",
            type: "checkbox",
            class: "mr-3",
            checked: __props.modelValue ? __props.modelValue.includes(optionValue) : false,
            onChange: ($event: any) => (onChanged(optionValue))
          }, null, 40, _hoisted_5),
          _createTextVNode(" " + _toDisplayString(optionLabel), 1)
        ]))
      }), 128)),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})